import * as i0 from '@angular/core';
import { Pipe, Component, Input, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
function SvgSpriteIconComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
    i0.ɵɵpipe(1, "sanitizeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 3, ctx_r0.htmlText), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-hidden", ctx_r0.ariaHidden)("aria-label", ctx_r0.ariaLabel);
  }
}
class SanitizeHtmlPipe {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(v) {
    return this.sanitizer.bypassSecurityTrustHtml(v);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SanitizeHtmlPipe_Factory(t) {
      return new (t || SanitizeHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "sanitizeHtml",
      type: SanitizeHtmlPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SanitizeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'sanitizeHtml'
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], null);
})();
class SvgSpriteIconComponent {
  constructor() {}
  ngOnChanges() {
    if (!this.iconName) {
      return;
    }
    const el = document.querySelector(`symbol#${this.iconName}`);
    this.htmlText = `<svg class="${this.wrapperClass}" aria-label=${this.ariaLabel}" style="${this.styleData}">` + `<use href="${!el ? this.spritePath : ''}#${this.iconName}" ></use></svg>`;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SvgSpriteIconComponent_Factory(t) {
      return new (t || SvgSpriteIconComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SvgSpriteIconComponent,
      selectors: [["cxone-svg-sprite-icon"]],
      inputs: {
        iconName: "iconName",
        spritePath: "spritePath",
        wrapperClass: "wrapperClass",
        styleData: "styleData",
        ariaLabel: "ariaLabel",
        ariaHidden: "ariaHidden"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "svg-sprite-icon", "role", "img", 3, "innerHtml", 4, "ngIf"], ["role", "img", 1, "svg-sprite-icon", 3, "innerHtml"]],
      template: function SvgSpriteIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SvgSpriteIconComponent_div_0_Template, 2, 5, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.htmlText);
        }
      },
      dependencies: [i1$1.NgIf, SanitizeHtmlPipe],
      styles: [".svg-sprite-icon[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SvgSpriteIconComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-svg-sprite-icon',
      template: "<div *ngIf=\"htmlText\" class=\"svg-sprite-icon\"\n     [attr.aria-hidden]=\"ariaHidden\"\n     [attr.aria-label]=\"ariaLabel\"\n     role=\"img\"\n     [innerHtml]=\"htmlText | sanitizeHtml\"></div>\n",
      styles: [".svg-sprite-icon{display:inline-block;vertical-align:middle}\n"]
    }]
  }], () => [], {
    iconName: [{
      type: Input
    }],
    spritePath: [{
      type: Input
    }],
    wrapperClass: [{
      type: Input
    }],
    styleData: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    ariaHidden: [{
      type: Input
    }]
  });
})();
class SvgSpriteIconModule {
  /** @nocollapse */static {
    this.ɵfac = function SvgSpriteIconModule_Factory(t) {
      return new (t || SvgSpriteIconModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SvgSpriteIconModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, HttpClientModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SvgSpriteIconModule, [{
    type: NgModule,
    args: [{
      declarations: [SvgSpriteIconComponent, SanitizeHtmlPipe],
      imports: [CommonModule, HttpClientModule],
      exports: [SvgSpriteIconComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SanitizeHtmlPipe, SvgSpriteIconComponent, SvgSpriteIconModule };
